import React from 'react'
import { checkTextTranslation } from '../../utils/useful'
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';


class CaptchaInput extends React.Component {
    state = {
    }

    componentDidMount() {
        loadCaptchaEnginge(6, '#fff', '#000', 'lower');
    }
    componentDidUpdate(prevProps) {
        // console.log('heeeeerrrrrrrrrrrrrrrrrrr22211111',this.props.loginError);
        if(this.props.loginError && this.props.loginError != prevProps.loginError ){
            // console.log('heeeeerrrrrrrrrrrrrrrrrrr222');

            loadCaptchaEnginge(6, '#fff', '#000', 'lower');
        }
    }

    changeInputValue(target) {

        let value = (target.validity.valid) ? target.value : null

        // let user_captcha = value;
        // let user_captcha = document.getElementById("user_captcha_input").value;

        // if (validateCaptcha(user_captcha) == true) {
        //     alert("Captcha Matched");
        //     // loadCaptchaEnginge(6);
        //     // this.state.text = "";
        //     // this.setState({ text: '' })
        //     value = ''
            if (value !== null) {

                this.props.changeValue(this.props.header.key, value, this.props.extra)
            }
            // document.getElementById("user_captcha_input").value = "";
        // } else {
        //     alert("Captcha Does Not Match");
        //     value = ''
        //     // this.setState({ text: '' })
        //     // document.getElementById("user_captcha_input").value = "";
        //     // document.getElementById("user_captcha_input").value = "";
        // }
    }


    render() {
        return (
            <>
                <div className="w-100 h-100">
                    <input ref={el => this.input = el} spellCheck={this.props.header.information.spellCheck} value={this.props.data ? this.props.data : ''} onChange={(e) => this.changeInputValue(e.target)} placeholder={checkTextTranslation(this.props.header.information.placeholder)} disabled={this.props.disabled || this.props.header.information?.disabled} className="transpanet-input" />
                </div>
                <div className='test-captcha ' style={{}}>

                    {/* <LoadCanvasTemplate reloadText={`<img src='/images/icons8-refresh-100.png' width='20px' />`} /> */}
                    <LoadCanvasTemplate reloadText={`<img src=${this.props.header.information.captchaIcon} width='20px' />`} />
                </div>
            </>
        )
    }
}

export default CaptchaInput;